import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { submitKeysOf } from '../components/workflow/useWorkflowPerms';
import NowName from '../components/shared/NowName';
import WorkflowListShell from '../components/workflow/WorkflowListShell';
import { EngagementName, stripDupFyeLabel } from '../components/workflow/CoverageDisplay';
import WorkflowStatusBadge from '../components/workflow/WorkflowStatusBadge';
import { formatDateShort } from '../utils/dateFormat';

// Signed Financial Statements Amendment — list page (docs/modules/workflow-fs.md §6). fs-only
// (QC35 corrections go through QC35 Form Amendment).
const WorkflowFsa = () => {
  const { hasPermission } = useAuth();
  return (
    <WorkflowListShell
      title="Signed Financial Statements Amendment"
      subtitle="Corrections to approved signed financial statements."
      newTo="/workflow/fsa/new"
      canCreate={submitKeysOf('fsa').some(hasPermission)}
      apiPath="/api/workflow/fsa"
      searchPlaceholder="Search request no / requester…"
      width="mid"
      rowTo={(r) => `/workflow/fsa/${r.id}`}
      columns={[
        {
          key: 'requestNo',
          label: 'Request',
          sortKey: 'requestNo',
          className: 'whitespace-nowrap',
          render: (r) => (
            <Link
              to={`/workflow/fsa/${r.id}`}
              onClick={(e) => e.stopPropagation()}
              className="text-blue-600 hover:text-blue-800 font-medium"
            >
              {r.requestNo}
            </Link>
          ),
        },
        { key: 'engagementLabel', label: 'Engagement', sortKey: 'engagementLabel', render: (r) => <EngagementName name={stripDupFyeLabel(r.engagementLabel)} serviceDescription={r.serviceDescription} /> },
        { key: 'status', label: 'Status', sortKey: 'status', render: (r) => <WorkflowStatusBadge status={r.status} /> },
        // AI-approved rows carry no reviewer — the badge is the marker that
        // tells them apart from human-reviewed ones at a glance.
        {
          key: 'reviewer',
          label: 'Reviewer',
          sortKey: 'reviewer',
          className: 'whitespace-nowrap',
          render: (r) => (r.aiApproved
            ? (
              <span className="px-1.5 py-0.5 rounded text-[10px] font-medium bg-violet-50 text-violet-700">
                AI review
              </span>
            )
            : <NowName value={r.reviewerName} now={r.reviewerNameNow} className="text-slate-600" />),
        },
        { key: 'requester', label: 'Requested By', className: 'text-slate-600', render: (r) => r.requesterEmail },
        { key: 'createdAt', label: 'Submitted', sortKey: 'createdAt', className: 'text-slate-600 whitespace-nowrap', render: (r) => formatDateShort(r.createdAt) },
      ]}
    />
  );
};

export default WorkflowFsa;
